/* ================================================================ */
// BUTTON COMPONENT | Button.jsx
/* ================================================================ */
/* ========================================== */
// Imports
/* ========================================== */
import React, {useCallback} from 'react';
import PropTypes from 'prop-types';
import useReactRouter from 'use-react-router';
// Material UI
import Fab from '@material-ui/core/Fab';
import Icon from '../../components/Icon';
import makeStyles from '@material-ui/styles/makeStyles';
/* ========================================== */
// Constants
/* ========================================== */
const ActionTypes = {
    HISTORY: 'history'
};
/* ========================================== */
// Style Settings
/* ========================================== */
const useStyles = makeStyles(theme => ({
    root: {
        zIndex: 10,
        backgroundColor: theme.palette.secondary.contrastText,
        color: theme.palette.secondary.main,
        width: '3.5rem',
        height: '3.5rem'
    },
    icon: {

    }
}));
// TODO: change action param to specific type formats with required values (history type, ui reducer type)
/* ========================================== */
/**
 * Action Button
 * -------------
 * Floating action button which triggers an action
 * according to specified parameters
 *
 * @param {object} props component props
 * @param {string} props.label button label
 * @param {string} props.colour button icon colour
 * @param {string | object} props.icon button icon
 * @param {string | element} props.activeIcon button active state icon
 * @param {string} props.action action type <history|ui>
 * @param {string} props.uri action uri
 * @param {object} props.styles style overrides
 */
const ActionButton = ({
    label,
    icon,
    action,
    uri,
    styles
}) => {
    const classes = useStyles();
    const {history} = useReactRouter();
    const defaultIcon = (typeof icon === 'object') ? icon.default : icon;
    /* ======================== */
    // HANDLERS
    /* ======================== */
    /* ========================================== */
    /**
     * Handle Click
     * ------------
     * Triggers button's action
     *
     * @param {string} action action type
     * @param {string} uri history action uri
     */
    const handleClick = useCallback(
        () => {
            console.debug(`${ActionButton.displayName} | `, `handleClick | ${action}`);
            history.push(uri);
        },
        [action, uri],
    );
    /*
    const ButtonIcon = () => (typeof icon === 'string') ?
        <Icon classes={{root: classes.icon}} color="secondary">{icon}</Icon>
        : (
            <img
                className={classes.activeIcon}
                src={`data:image/svg+xml;base64, ${btoa(icon)}`}
                alt={`${label} button icon`}
            />
        );
    */
    return (
        <Fab
            style={styles}
            onClick={handleClick}
            aria-label={label}
            className={classes.root}
        >
            <Icon
                label={label}
                icon={defaultIcon}
                //activeIcon={icon.active || undefined}
                //isActive={isActive}
            />
        </Fab>
    );
};
ActionButton.propTypes = {
    label: PropTypes.string.isRequired,
    // Icon Props
    icon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            default: PropTypes.string.isRequired,
            active: PropTypes.string,
            colour: PropTypes.string,
            activeColour: PropTypes.string,
            styles: PropTypes.object,
            activeStyles: PropTypes.object
        })
    ]).isRequired,
    action: PropTypes.oneOf(Object.values(ActionTypes)),
    uri: PropTypes.string,
    styles: PropTypes.object
};
ActionButton.defaultProps = {
    icon: 'close',
    action: ActionTypes.HISTORY,
    uri: '/',
    styles: {}
};
ActionButton.displayName = 'ActionButton';
ActionButton.ActionTypes = ActionTypes;
/* ========================================== */
// Export
/* ========================================== */
export default ActionButton;